import type { PermissionCode } from '@pms/shared';
import { PERMISSION_MODULE_CODE } from '@pms/shared';
import { useAuth } from './useAuth';

export function usePermission() {
  const { isSuperAdmin, permissions, modules } = useAuth();

  const has = (code: PermissionCode): boolean => {
    if (isSuperAdmin) return true;
    if (!permissions.includes(code)) return false;
    const requiredModule = PERMISSION_MODULE_CODE[code];
    if (requiredModule && !modules.includes(requiredModule)) return false;
    return true;
  };

  return {
    has,
    hasAny: (codes: PermissionCode[]): boolean => isSuperAdmin || codes.some(has),
    hasAll: (codes: PermissionCode[]): boolean => isSuperAdmin || codes.every(has),
  };
}
